import { create } from 'zustand';
import { PaginationType } from '../types/pagination';
import { useAlertStore } from './use-alert-store';
import { fetchScans, FetchScansRequest, ScanType } from './api/scans-api';

interface Store {
  scans?: ScanType[];
  fetchScans: (params: FetchScansRequest) => Promise<void>;
  isLoading?: boolean;
  pagination?: PaginationType;
}

export const useScansStore = create<Store>((set) => ({
  fetchScans: async (params) => {
    set({ isLoading: true });
    try {
      const { logs, ...other } = await fetchScans(params);
      set({ scans: logs, pagination: other });
    } catch (e) {
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось получить данные по филиалам', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },
}));
